import { queryOptions } from '@tanstack/react-query';
import { Application, AppStatus } from '../types';
import { unifiedApiClient } from './client';

const applications = async (statuses?: AppStatus[]) => {
  const hasStatuses = !!statuses && statuses.length > 0;
  const { data } = await unifiedApiClient.GET(
    '/client/application/v1/applications',
    hasStatuses ? ({ params: { query: { status: statuses } } } as never) : undefined,
  );

  return (data as unknown as Application[] | null) ?? null;
};

export const applicationsOpts = ({ statuses }: { statuses?: AppStatus[] }) => {
  const normalizedStatuses = [...(statuses ?? [])].sort();

  return queryOptions<Application[] | null>({
    queryKey: ['applications', normalizedStatuses],
    queryFn: () => applications(statuses)
  });
};
